import { useState, useCallback } from 'react';

export interface RequestConfig {
    request_type: "json" | "form" | "multi-form" | "text" | "xml"
    url: RequestInfo | URL;
    method?: string | undefined;
    headers?: Headers | undefined;
    body?: any | undefined;
}

const useHttp = () => {
    const [status, setStatus] = useState<'idle' | 'loading' | 'error'>('idle');    
    const [error, setError] = useState(null);

    const sendRequest = useCallback(async (requestConfig: RequestConfig, applyData: any) => { 
        setStatus('loading');
        setError((v) => null);

        try {
            if (!requestConfig.headers) {
                requestConfig.headers = new Headers();
            }

            const headers = requestConfig.headers;
            const contentTypeMap: Record<string, string> = {
                'json'          : 'application/json',
                'form'          : 'application/x-www-form-urlencoded',
                'multi-form'    : 'multipart/form-data',
                'xml'           : 'application/xml',
                'text'          : 'text/plain',                
            };

            const contentType = contentTypeMap[requestConfig.request_type];
            if (contentType) {                
                headers.set('Content-Type', contentType);
            }
           
            let body = "";
            if (requestConfig.request_type && requestConfig.request_type === "json") {
                body = requestConfig.body ? JSON.stringify(requestConfig.body) : JSON.stringify({})
            } else {
                body = requestConfig.body
            }

            const response = await fetch(requestConfig.url, {
                method: requestConfig.method ?? "GET",
                headers: requestConfig.headers,
                body: body
            });

            if (!response.ok) {
                if (response.status === 403) {
                    const data = await response.json()
                    if (applyData) {
                        applyData({ validation: data });
                    }
                    console.log(data)
                } else {
                    throw new Error("request failed");
                }               
            }else if (applyData) {
                const data = await response.json();
                applyData({ data: data, validation: null});
            }               
        } catch (e: any) {
            setStatus('error');
            setError((v) => e?.message || "something went wrong!!");
        } finally {
            setStatus('idle');
        }
    }, []);

    return { status, error, sendRequest };
}

export default useHttp;